const mutations = {
  APPEND_DELIVERIES(state, data) {
    const newEntries = [];
    data.forEach((entry) => {
      newEntries.push({ ...entry, checked: state.allDeliveriesSelected });
    });
    state.all.push(...newEntries);
    state.page += 1;
  },
  PAGINATION_CHECK(state, data) {
    state.disablePagination = data;
  },
  RESET_STATES(state) {
    state.page = 1;
    state.all = [];
    state.disablePagination = false;
    state.allDeliveriesSelected = false;
  },
  SET_FILTER(state, data) {
    state.filter = data;
  },
  SET_REQUEST_DETAILS(state, data) {
    state.requestDetails = data;
  },
  RESET_PAGINATION(state) {
    state.transporterPagination = 1;
    state.masterTransporterList = [];
  },
  APPEND_REQUESTS(state, data) {
    state.all.push(...data);
    state.page += 1;
  },
};
export default mutations;
